import React from "react";
import darkLogo from "../../assets/img/darkLogo.png";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "../../assets/styles/main.css";
import "../../assets/styles/responsive.css";

export default function Footer() {
  return (
    <div className=" text-white pt-5 pb-3" style={{ backgroundColor: "#fff" }}>
      <div className="container">
        <div
          className="row text-center text-sm-start"
          style={{
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "20px",
            marginBottom: "60px",
          }}
        >
          <div className="col-6 col-md-2  mb-md-0 footer-links ">
            <h5
              className="text-lg font-extrabold "
              style={{
                color: "#030621",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              Products
            </h5>
            <ul className="list-unstyled mt-2">
              <li>
                <Link className="text-para" to="/">
                  The Platform
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Prospecting
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Leadbud API
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Buyer Intelligence
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Enrichment
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Integrations
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Lusha Extension
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Engage
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-2 mb-md-0 footer-links ">
            <h5
              className="text-lg font-semibold "
              style={{
                color: "#030621",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              Company
            </h5>
            <ul className="list-unstyled mt-2">
              <li>
                <Link className="text-para" to="/">
                  About
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Pricing
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/affiliate-program">
                  Customers{" "}
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/privacy-policy">
                  Our Data
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/terms-condition">
                  Newsroom
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/terms-condition">
                  Careers
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-2  mb-md-0 footer-links ">
            <h5
              className="text-lg font-semibold "
              style={{
                color: "#030621",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              Information
            </h5>
            <ul className="list-unstyled mt-2">
              <li>
                <Link className="text-para" to="/">
                  Data Sources
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Community Program
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Community Terms of Use
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Community FAQ
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-2  mb-md-0 footer-links ">
            <h5
              className="text-lg font-semibold "
              style={{
                color: "#030621",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              Legal
            </h5>
            <ul className="list-unstyled mt-2">
              <li>
                <Link className="text-para" to="/terms-condition">
                  Terms and Conditions
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/privacy-policy">
                  Privacy Notice
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Cookie Policy & Settings
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Vendor Code of Conduct
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Privacy Center
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Opt Out
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  TIA
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Do Not Sell My Info
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-2  mb-md-0 footer-links ">
            <h5
              className="text-lg font-semibold"
              style={{
                color: "#030621",
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              Resources
            </h5>
            <ul className="list-unstyled mt-2">
              <li>
                <Link className="text-para" to="/blog">
                  Blog
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Help Center Support
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/docs">
                  API Documentation
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Leadbud Alternatives
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Search by Industry
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Revenue Calculator
                </Link>
              </li>
              <li>
                <Link className="text-para" to="/">
                  Sales Script Generator
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="row text-center text-sm-start align-items-center justify-content-between">
          <div className="col-12 col-sm-4 col-md-2 mb-3 mb-sm-0 ">
            <img className="img-fluid" src={darkLogo} alt="Logo" />
          </div>
          <div className="col-12 col-md-4 mb-3 mb-sm-0 ">
            <div className="d-flex justify-content-center justify-content-md-end">
              <Link
                className="text-green mx-1"
                to="/"
                style={{ color: "#4bf877" }}
              >
                <FaFacebookF
                  className=" p-2 rounded-circle"
                  size={30}
                  style={{ borderColor: "#4bf877", border: "solid 1px" }}
                />
              </Link>
              <Link
                className="text-green mx-1"
                to="/"
                style={{ color: "#4bf877" }}
              >
                <FaLinkedinIn
                  className=" p-2 rounded-circle"
                  size={30}
                  style={{ borderColor: "#4bf877", border: "solid 1px" }}
                />
              </Link>
              <Link
                className="text-green mx-1"
                to="/"
                style={{ color: "#4bf877" }}
              >
                <FaTwitter
                  className="p-2 rounded-circle"
                  size={30}
                  style={{ borderColor: "#4bf877", border: "solid 1px" }}
                />
              </Link>
              <Link
                className="text-green mx-1"
                to="/"
                style={{ color: "#4bf877" }}
              >
                <FaInstagram
                  className="p-2 rounded-circle"
                  size={30}
                  style={{ borderColor: "#4bf877", border: "solid 1px" }}
                />
              </Link>
            </div>
          </div>
        </div>
        <hr
          style={{
            marginTop: "20px",
            backgroundColor: "black",
            color: "black",
            marginBottom: "20px",
          }}
        />
        <div className="order-md-1" style={{ flexShrink: 0 }}>
          <p
            className="text-sm md:text-md text-para mb-0 "
            style={{ fontSize: "14px", color: "#7b7b7b" }}
          >
            Copyright © 2023 Leadbud.io All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  );
}
